// extracted by mini-css-extract-plugin
export default {"label_spec":"ProteinCalculator_label_spec__ofeWj","container":"ProteinCalculator_container__8317H","sectionHeading":"ProteinCalculator_sectionHeading__q4xHE"};